import { render, staticRenderFns } from "./CollectIframe.vue?vue&type=template&id=390d7ec6&"
import script from "./CollectIframe.vue?vue&type=script&lang=js&"
export * from "./CollectIframe.vue?vue&type=script&lang=js&"
import style0 from "./CollectIframe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports